module.exports = __webpack_public_path__ + "img/4967.8a7c4b0e.jpg";